import TrashModal from './TrashModal';
import FloatingHelper from "../components/FloatingHelper";
import TrashOptimizeModal from "./TrashOptimizeModal";

var flagModal = false;

export default class Situation {
  constructor(situation, instance) {
    this.situation = situation;
    this.wrapper = instance.wrapper;
    this.checkboxes = situation.querySelectorAll('input[type="checkbox"]');
    this.editBtns = situation.querySelectorAll('.edit-form');
    this.dataText = JSON.parse(this.wrapper.dataset.text);
    this.modals = [];
    this.counters = instance.counters;

    this.events();
  }

  events() {
    this.checkboxes.forEach( (checkbox) => {
      checkbox.addEventListener('click', (e) => {



        if (checkbox.checked) {

          jQuery('.alert.floating-helper.step-1').removeClass('open');
          jQuery('.alert.floating-helper.step-1').remove();

          let newModal = this.addModal(checkbox, e.isTrusted);
          document.body.style.cursor = "wait";
          newModal.then( () => {
            document.body.style.cursor = "default";
          } );


        } else {
          let confirmDialog = confirm(this.dataText.confirmCancel);
          if(confirmDialog) {
            this.modals[checkbox.value].removeModal();
            delete this.modals[checkbox.value];
            let editBtn = checkbox.parentNode.querySelector('.edit-form');
            editBtn.classList.remove("visible");
            this.updateTotal(this.situation.dataset.situation);
          } else {
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }, false);
    } );

    this.editBtns.forEach( (button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.modals[button.dataset.value].open();
      }, false);
    } );
  }

  customEvent(situation) {
    document.addEventListener('modalRowUpdate', () => {
      this.updateTotal(situation);
    });
  }



  async addModal(checkbox, isTrusted ) {
    const data = await this.getTrashData(checkbox.value, checkbox.dataset.situation);
    this.situation.insertAdjacentHTML('beforeend', data);
    let modal = this.situation.querySelector(`#form-${checkbox.dataset.situation}-${checkbox.value}`);
    let editBtn = checkbox.parentNode.querySelector('.edit-form');
    editBtn.classList.add("visible");
    this.modals[checkbox.value] = new TrashModal(modal);
    if (isTrusted){
      this.modals[checkbox.value].open();
    }

    this.customEvent(checkbox.dataset.situation);
    this.updateTotal(checkbox.dataset.situation);


    if (!flagModal){
      let fh = new FloatingHelper(jQuery);
      fh.init(0, jQuery('.floating-helper.step-2'));
      flagModal = true;
    }else{
      jQuery('.floating-helper.step-2').remove();
    }

  }

  async getTrashData(key, situation) {
    const response = await fetch(`/api/hygiene/trash/add/${key}/${situation}`);
    return await response.text();
  }



  hide() {
    this.situation.classList.add('hidden');
  }

  show() {
    this.situation.classList.remove('hidden');
  }

  updateTotal(situation) {
    let total = 0;
    let total_l = 0;

    if(Object.keys(this.modals).length > 0) {
      Object.keys(this.modals).forEach((modal) => {
        modal = this.modals[modal];
        total = total + modal.getTotal();
        total_l = total_l + modal.getTotalL();
      });
    } else {
      total = 0;
      total_l = 0;
    }


    this.counters[situation].dataset.total = total;
    this.counters[situation].dataset.total_l = total_l;

    //this.counters[situation].querySelector('.total').innerHTML = `${total} &euro; / ${total_l}L.`;

    
    this.counters[situation].querySelector('[data-total-price]').innerHTML  = total;
    this.counters[situation].querySelector('[data-total-quantity]').innerHTML  = total_l;
  

    let firstCounter = this.counters[Object.keys(this.counters)[0]];
    let secondCounter = this.counters[Object.keys(this.counters)[1]];

    let compare = Number(firstCounter.dataset.total) - Number(secondCounter.dataset.total);
    let compare_l = Number(secondCounter.dataset.total_l) - Number(firstCounter.dataset.total_l);

    let gain = secondCounter.querySelector('.gain');
    let prefix = "";
    let prefix_l = "+";

    let win_l = '';
    let win = '';

    if(compare > 0) {
      gain.classList.remove('neutral');
      gain.classList.remove('loss');
      win = 'win';
    } else if(compare === 0) {
      gain.classList.remove('loss');
      gain.classList.add('neutral');
      prefix = "";
    } else if(compare < 0) {
      gain.classList.remove('neutral');
      gain.classList.add('loss');
      prefix = "";
    }

    if(compare_l == 0) {
      prefix_l = "";
    } else if(compare_l < 0) {
      prefix_l = "";
      //win_l = 'win';
    }

    //gain.innerHTML = '<span class="eu '+win+'">' + `${prefix}${compare} &euro;` +'</span> / <span class="l ' + win_l +'">'+ `${prefix_l}${compare_l}L.` +'</span>';

    if (gain.parentElement.querySelector('[data-total-price]')) gain.parentElement.querySelector('[data-total-price]').innerHTML  = `${prefix}${compare}`;
    if (gain.parentElement.querySelector('[data-total-quantity]')) gain.parentElement.querySelector('[data-total-quantity]').innerHTML  = `${prefix_l}${compare_l}`;

  }
}
